"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
SVGInject(document.querySelectorAll("img.injectable"));
var Main = {
  buttonBody: '',
  tickerData: '',
  animationParams: {
    duration: 500,
    progress: function progress(animation, _progress) {
      $('#progress').width(parseInt(_progress * 100) + '%').text(parseInt(_progress * 100) + '%');
    },
    complete: function complete() {
      $('#progress').css('width', '0%').text('0%');
    }
  },
  onload: document.addEventListener('DOMContentLoaded', function () {
    Main.init();
  }),
  init: function init() {
    this.bind();
    this.hamburgerAnima();
    this.onShow();
    this.onClose();
    this.fnHeight();
    this.currency();
    this.language();
    this.Fnaccordion();
    this.ClosePopup();
    this.PaymentCheck();
    this.OpenCabinetMenu();
    this.FnHelpAccordion();
    this.fnMessagesTabs();
    this.passwordStrengthChecker();
    this.dynamicCounter();
    this.checkedBackground();
    this.showDashboardContent();
    this.handleClick();
    this.scrollToBottom();
    this.emojionearea();
    this.textareaAutoHeight();
    this.showTips();
    this.selectToStep();
    this.checkedShowTextarea();
    this.showHoverPopup();
    this.toggleShowMenu();
    this.selectTransportsPopup();
    this.homeTabs();
    this.newHeader();
    this.menuOpenNew();
    this.FnAccordion();
    this.cookieBlock();
    this.popupDownloadOurAppsOnMainPage();
    // this.welcomeBlock();
    this.tickerBlock();
    this.preloaderProfilePopUp();
    // this.tabAll();
    this.hoverActiveCart();
    this.scrollToPartners();
    this.whatMoveAccordion();
  },
  bind: function bind() {
    $(document).on('click', '.technical-class-needed-login', function (event) {
      event.preventDefault();

      // let url = LOGIN_URL;
      var url = $(this).attr('data-url');
      window.location.replace(url);
    }).on('click', '.close-banner', function (event) {
      event.preventDefault();
      $('.main').removeClass('p_banners_top');
      $('.banners').remove();
    }).on('click', '.change-language', function (event) {
      event.preventDefault();
      window.location.replace($(this).attr('data-href'));
    }).on('click', '.filling-account__icon', function (event) {
      event.preventDefault();
      $('.filling-account__block').slideUp(Main.animationParams);
      Main.ajax.closeAccountFillingInfoBlock();
    }).on('click', '.select-driver__btn', function (e) {
      if ($(this).closest('.select-driver').find('.select-driver__info').hasClass("select-driver__info--active")) {
        $('.select-driver__info').removeClass("select-driver__info--active");
        $('.select-driver__selects').slideUp("hide");
      } else {
        $(this).closest('.select-driver').find('.select-driver__selects').slideDown("show");
        $(this).closest('.select-driver').find('.select-driver__info').addClass("select-driver__info--active");
      }
    }).on('click', '.select-languages__btn', function (e) {
      if ($(this).closest('.select-languages').find('.select-languages__info').hasClass("select-languages__info--active")) {
        $('.select-languages__selects').slideUp("hide");
        $('.select-languages__info').removeClass("select-languages__info--active");
      } else {
        $(this).closest('.select-languages').find('.select-languages__selects').slideDown("show");
        $(this).closest('.select-languages').find('.select-languages__info').addClass("select-languages__info--active");
      }
    }).on('click', '.price-serv__close', function (e) {
      $("#" + $(this).closest('.delete-item').attr('data-show')).prop('checked', false);
      $("." + $(this).closest('.delete-item').attr('data-show')).hide();
    }).on('click', function (e) {
      if (!$(e.target).closest(".select-driver__wrapper").length) {
        $('.select-driver__selects').slideUp("hide");
        $('.select-driver__info').removeClass("select-driver__info--active");
      }
      if (!$(e.target).closest(".select-languages__wrapper").length) {
        $('.select-languages__selects').slideUp("hide");
        $('.select-languages__info').removeClass("select-languages__info--active");
      }
      e.stopPropagation();
    }).on('keypress', 'input.input-numbers', function (event) {
      if ((event.which != 46 || $(this).val().indexOf('.') != -1) && (event.which < 48 || event.which > 57)) {
        event.preventDefault();
      }
    }).on('keypress', 'input.input-integer-numbers', function (event) {
      if (event.which < 48 || event.which > 57) {
        event.preventDefault();
      }
    }).on('change', '.form-step__checkbox-other', function (event) {
      if ($(this).find('input').is(':checked')) {
        $(this).next().find('input').css("display", "flex");
        $(this).next().css("display", "flex");
        $(this).next().find('input').prop('disabled', false);
      } else {
        $(this).next().find('input').css("display", "none");
        $(this).next().css("display", "none");
        $(this).next().find('input').prop('disabled', true);
      }
    }).on('click', '.mini-chat__header__close', function () {
      $(".popup-bg-opacity--chat").hide();
      Main.onClose();
    }).on('click', '.mini-chat__back', function () {
      $(".popup-bg-opacity--chat").hide();
      Main.onClose();
    }).on('click', '.pop-up-service-close', function () {
      $(".pop-up-service").hide();
      Main.onClose();
    }).on('click', '.close-popup-avatar', function () {
      $('.pop-up-profile').hide();
      document.querySelector('body').classList.remove('body-hidden');
    }).on('click', '.onboarding-language__language', function () {
      $('.language').toggleClass('language-active');
    }).on('click', '.close-popup', function () {
      $(".pop-up").hide();
      $(".pop-up-tasks").hide();
      $(".full-load-popup").hide();
      $(".archive-trip").hide();
      Main.onClose();
    }).on('click', '.chat-info__close', function () {
      Main.createCookie('moovick-chat-info-on-chat-window', 1, 7);
      Main.showHideBlockByCookies('moovick-chat-info-on-chat-window', $(this).closest('.chat-info'), 7);
    }).on('click', '.minus', function (event) {
      event.preventDefault();
      var stepNumber = $(this).closest('.form-step__number, .price-count__number');
      var $input = $(this).parent().find('input');
      var counter = parseFloat(stepNumber.attr('data-counter'));
      var yellow = parseFloat(stepNumber.attr('data-yellow'));
      var red = parseFloat(stepNumber.attr('data-red'));
      var roundValue = Number.isInteger(counter) ? 0 : 1;
      if (parseFloat($input.val()) > parseFloat($(this).data('value'))) {
        var count = (parseFloat($input.val()) - counter).toFixed(roundValue);
        count = count < 0 ? 1 : count;
        $input.val(count);
        $input.change();
        var valueNumber = stepNumber.find('input').val();
        stepNumber.find('.form-step__set-price, .price-count__set-price').find('span').text(valueNumber);
        var colorBlock = stepNumber.find('.form-step__set-price, .price-count__set-price');
        Main.changeCounterColor(colorBlock, parseFloat($input.val()), yellow, red);
        stepNumber.find('.plus').removeClass('disabled');
      }
      if (parseFloat($input.val()) === parseFloat($(this).data('value'))) {
        $(this).addClass('disabled');
      }
    }).on('click', '.plus', function (event) {
      event.preventDefault();
      console.log('plus');
      var stepNumber = $(this).closest('.form-step__number, .price-count__number');
      var $input = stepNumber.find('input');
      var counter = parseFloat(stepNumber.attr('data-counter'));
      var yellow = parseFloat(stepNumber.attr('data-yellow'));
      var red = parseFloat(stepNumber.attr('data-red'));
      var roundValue = Number.isInteger(counter) ? 0 : 1;
      console.log('stepNumber ', stepNumber);
      console.log('$input ', $input);
      console.log('counter ', counter);
      console.log('yellow ', yellow);
      console.log('red ', red);
      console.log('roundValue ', roundValue);
      console.log('1 check ', parseFloat($input.val()) < parseFloat($(this).data('value')));
      if (parseFloat($input.val()) < parseFloat($(this).data('value'))) {
        $input.val((parseFloat($input.val()) + counter).toFixed(roundValue));
        $input.change();
        var valueNumber = stepNumber.find('input').val();
        stepNumber.find('.form-step__set-price, .price-count__set-price').find('span').text(valueNumber);
        var colorBlock = stepNumber.find('.form-step__set-price, .price-count__set-price');
        Main.changeCounterColor(colorBlock, parseFloat($input.val()), yellow, red);
        stepNumber.find('.minus').removeClass('disabled');
      }
      console.log('1 check ', parseFloat($input.val()) === parseFloat($(this).data('value')));
      if (parseFloat($input.val()) === parseFloat($(this).data('value'))) {
        $(this).addClass('disabled');
      }
    }).on('click', '.my-task__close', function (event) {
      event.preventDefault();
      $(this).parent().hide();
    }).on('change', '#checked-all', function (e) {
      if (this.checked) {
        $('.select-transports__items').find('input').prop("checked", true);
      } else {
        $('.select-transports__items').find('input').prop("checked", false);
      }
    }).on('click', '.no-action', function (event) {
      event.preventDefault();
    }).on('click', '#cookie-agree', function (event) {
      Main.createCookie('moovick-cookie', 1);
      Main.cookieBlock();
    }).on('click', '.reminder--popup .container .reminder--popup--close-function', function () {
      // $(".reminder--popup").removeClass('active');
      Main.createCookie('moovick-download-our-app-popup', 1, 7);
      Main.popupDownloadOurAppsOnMainPage();
    }).on('click', '.open-calculator-main-page', function (event) {
      event.preventDefault();
      $('.new-calculator').show();
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".new-calculator").offset().top - 90
      }, 1500);
    }).on('click', function (e) {
      if (!($(e.target).parents('.popup-hide .container-main').length || $(e.target).hasClass('popup-container'))) {
        // $(".popup-hide").hide();
      }
    })
    // .on('click', function (e) {
    // if (!(($(e.target).parents('.popup-bg-opacity--chat').length))) {
    //     $(".popup-bg-opacity--chat").hide();
    //     Main.onClose();
    // }
    // })
    .on('click', function (e) {
      if (!$(e.target).parents('.pop-up-tasks').length) {
        $(".pop-up-tasks").hide();
        Main.onClose();
      }
    }).on('click', function (e) {
      if (!$(e.target).parents('.pop-up-service').length) {
        $(".pop-up-service").hide();
        Main.onClose();
      }
    }).on('click', function (e) {
      if ($(e.target).parents('.full-load-popup').length) {
        $(".full-load-popup").hide();
        Main.onClose();
      }
    }).on('click', function (e) {
      if (!$(e.target).parents('.offer-details-popup').length) {
        $(".offer-details-popup").hide();
        Main.onClose();
      }
    }).on('click', '.offer-details-popup .pop-up__close', function (e) {
      $(".offer-details-popup").hide();
      Main.onClose();
    }).keydown(function (event) {
      if (event.keyCode == 9) {
        event.preventDefault();
        return false;
      }
    }).on('click', '.service-slider__item', function (event) {
      var title = $(this).find('.service-slider__text').html();
      var desc = $(this).find('.service-slider__desc').html();
      var img = $(this).find('.service-slider__icon').html();
      // Main.ajax.openServiceInfoPopup(title, desc, img); // open popup for services with info
    }).on('click', '.service-pop-up__close', function () {
      $('.service-pop-up').removeClass('active').addClass('not-active');
    }).on('click', '.calculator-bl__btn', function () {
      $('.calculator-bl__btn').removeClass('active');
      $(this).addClass('active');
      Main.collectDataForMoveCalculator();
    }).on('change', '.calculator-bl__input input', function () {
      Main.collectDataForMoveCalculator();
    }).on('click', '.select__item-custom-action', function () {
      Main.collectDataForMoveCalculator();
    }).on('click', '.profile-photo', function (event) {
      event.preventDefault();
    }).on('click', '.click-disabled', function (event) {
      event.preventDefault();
    }).on('click', '.close-post-task-photos-popup', function (event) {
      event.preventDefault();
      Step.showConfirmPhotoPopup = false;
      $('.post-not-photos-popup').removeClass('active');
    }).on('click', '.interception-click', function (event) {
      event.preventDefault();
      Main.ajax.trackingLinkClickInterception($(this).attr('href'));
    }).on('click', '.tags__item', function (event) {
      $('.tags__item').removeClass('active');
      $(this).addClass('active');
      Main.ajax.getPartnersList($(this).find('span').text().trim());
    }).on('click', '.register-service-close', function (event) {
      event.preventDefault();
      $('.register-service-popup-body').removeClass('active');
    }).on('click', '.check-request-general-popups', function (event) {
      event.preventDefault();
      Main.ajax.generalPopupsClose($(this).attr('data-href'), $(this).attr('data-id'));
    }).on('click', '.close-general-popups', function (event) {
      event.preventDefault();
      Main.ajax.generalPopupsClose('', $(this).attr('data-id'));
    }).on('click', '.reminer-general-popups', function (event) {
      event.preventDefault();
      Main.ajax.reminerGeneralPopups($(this).attr('data-id'));
    }).on('click', '.show-translation-button', function (event) {
      var element = $(this).attr('data-translate');
      var text = $(this).attr('data-text');
      var lang = $(this).attr('data-lang');
      if ($(this).hasClass('hide-translation')) {
        var translateElement = $("[data-translate-id=\"".concat(element, "\"]"));
        $(this).removeClass('hide-translation').find('p').text($(this).attr('data-text-stage-1'));
        translateElement.html(translateElement.hasClass('translator') ? '' : text);
      } else {
        Main.ajax.translateText($(this), element, text, lang);
      }
    }).on('click', '.openPopupTranslation', function () {
      $('.translation--popup').addClass('active');
      if ($(this).hasAttr('data-action')) {
        $('.turn-on-auto-translations-for-user').attr('data-action', $(this).attr('data-action'));
        if (Messages.isMiniChat) {
          $('.popup-bg-opacity--chat').removeClass('active');
        }
      }
    }).on('click', '.specialDealPaymentPopupClose', function () {
      $('.special-deal-payment--popup').removeClass('active');
    }).on('click', '.translationClose', function () {
      $('.translation--popup').removeClass('active');
    }).on('click', '.openPopupChooseLanguage', function () {
      $('.translation--popup').removeClass('active');
      $('.choose-language--popup').addClass('active');
      $('.turn-on-auto-translations-for-user').attr('data-action', $(this).attr('data-action'));
    }).on('click', '.translationPopupClose', function () {
      $('.choose-language--popup').removeClass('active');
    }).on('click', '.turn-on-auto-translations-for-user', function (event) {
      event.preventDefault();
      var lang = $('[name="languageAutoTranslation"]').val();
      Main.ajax.turnOnAutoTranslations($(this), lang);
    }).on('click', '.opened-private-chat--closed', function (event) {
      event.preventDefault();
      Main.ajax.generalPopupsClose('', $(this).attr('data-id'));
      $('.opened-private-chat--popup').removeClass('active');
    }).on('click', '.how-did-you-found-company-item', function (event) {
      event.preventDefault();
      $(this).closest('.answer-question-coupon--content').find('button').prop('disabled', false);
    }).on('click', '.answer-question-coupon--close', function (event) {
      event.preventDefault();
      $('.answer-question-coupon').removeClass('active');
    }).on('click', '.answer-question-coupon-button', function (event) {
      event.preventDefault();
      var answer = $(this).closest('.answer-question-coupon--content').find('[name="answer"]').val();
      Main.showPreloader($(this));
      Main.ajax.sendAnswerOnQuestionAboutWhereYouFoundCompany($(this), answer);
    });
    $('.close-popup').on('click', function (e) {
      $(".pop-up-tasks").hide();
      Main.onClose();
    });
    $('.offer-details-popup__close').on('click', function (e) {
      $(".offer-details-popup").hide();
      Main.onClose();
    });
    $('[name="SignupForm[code]"]').on('input paste click', function () {
      $(this).next().find('.error').hide();
    });
  },
  replaceContent: function replaceContent(value, targetPlace, replaceText) {
    var text = $(targetPlace).html();
    $(targetPlace).html(text.replace(replaceText, value));
  },
  collectDataForMoveCalculator: function collectDataForMoveCalculator() {
    setTimeout(function () {
      var tab = $('.calculator-bl__btn.active').attr('data-tab');
      var from = $('#calculator-from').val().trim();
      var to = $('#calculator-to').val().trim();
      var type = $('#calculator-vehicle-type').val().trim();
      var lat = $('#calculator-lat').val().trim();
      var lng = $('#calculator-lng').val().trim();
      var countryFrom = $('#calculator-country-from').val().trim();
      var countryTo = $('#calculator-country-to').val().trim();
      if (from.length > 0 && to.length > 0 && type.length > 0) {
        Main.ajax.calculateMove(tab, from, to, type, lat, lng, countryFrom, countryTo);
      } else {
        $("#calculator-total-amount").text('€');
        $('.calculator-bl__text').hide();
        $('.calculator-bl__submit').hide().attr('href', '');
      }
    }, 300);
  },
  tickerBlock: function tickerBlock() {
    var typeText = document.querySelector('#typed2');
    if (typeText) {
      $(function () {
        $("#typed2").typed({
          strings: Main.tickerData,
          typeSpeed: 50,
          backSpeed: 0,
          fadeOut: true,
          loop: true
        });
      });
    }
  },
  cookieBlock: function cookieBlock() {
    var cookie = Main.readCookie('moovick-cookie');
    if (cookie) {
      if (cookie === '1') {
        $(".cookies-info").fadeOut(500);
      } else {
        $(".cookies-info").fadeIn(500);
      }
    } else {
      Main.createCookie('moovick-cookie', 0);
      $(".cookies-info").fadeIn(500);
    }
  },
  popupDownloadOurAppsOnMainPage: function popupDownloadOurAppsOnMainPage() {
    var cookie = Main.readCookie('moovick-download-our-app-popup');
    if (cookie) {
      if (cookie === '1') {
        $(".reminder--popup").removeClass('active');
      } else {
        $(".reminder--popup").addClass('active');
      }
    } else {
      Main.createCookie('moovick-download-our-app-popup', 0, 7);
      $(".reminder--popup").addClass('active');
    }
  },
  showHideBlockByCookies: function showHideBlockByCookies(cookiesName, block) {
    var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 365;
    var cookie = Main.readCookie(cookiesName);
    if (cookie) {
      if (cookie === '1') {
        block.css('display', 'none');
      } else {
        block.css('display', 'flex');
      }
    } else {
      Main.createCookie(cookiesName, 0, days);
      block.css('display', 'flex');
    }
  },
  //
  // welcomeBlock: function () {
  //     let cookie = Main.readCookie('moovick-welcome-cookie');
  //
  //     if (cookie) {
  //         if (cookie === '1') {
  //             $("#welcome-popup").removeClass('active');
  //         } else {
  //             $("#welcome-popup").addClass('active');
  //         }
  //     } else {
  //         Main.createCookie('moovick-welcome-cookie', 0);
  //         $("#welcome-popup").addClass('active');
  //     }
  // },

  createCookie: function createCookie(name, value) {
    var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 365;
    var expires;
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
  },
  readCookie: function readCookie(name) {
    var nameEQ = encodeURIComponent(name) + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
    }
    return null;
  },
  fnHeight: function fnHeight() {
    window.addEventListener('resize', function () {
      var vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
    });
  },
  onShow: function onShow() {
    document.body.style.overflowY = 'hidden';
  },
  onClose: function onClose() {
    document.body.style.overflowY = 'visible';
  },
  hamburgerAnima: function hamburgerAnima() {
    var hamburgerIconOpen = document.querySelector(".hamburger-icon-open");
    var hamburgerIconClose = document.querySelector(".hamburger-icon-close");
    var hamburger = document.querySelector(".hamburger");
    var hamburgerContent = document.querySelector(".hamburger-content");
    if (hamburgerContent) {
      hamburgerIconOpen.addEventListener("click", function () {
        hamburger.classList.add("hamburger-active");
        hamburgerIconOpen.classList.add("icon-noactive");
        hamburgerIconClose.classList.add("icon-active");
        Main.onShow();
        // Main.onShow()
      });

      hamburgerIconClose.addEventListener("click", function () {
        hamburger.classList.remove("hamburger-active");
        hamburgerIconClose.classList.remove("icon-active");
        hamburgerIconOpen.classList.remove("icon-noactive");
        Main.onClose();
      });
    }
  },
  currency: function currency() {
    var buttonMobilleCurrency = document.querySelectorAll(".js-currency-mob");
    var buttonFooterCurrency = document.querySelector(".js-footer-currency");
    var buttonHeaderCurrency = document.querySelector(".js-header-currency");
    if (buttonFooterCurrency) {
      buttonFooterCurrency.addEventListener("click", function () {
        var FooterCurrencyBlock = document.querySelector(".js-footer-currency > .currency");
        FooterCurrencyBlock.classList.toggle("currency-active");
        var FooterLanguageBlock = document.querySelector(".js-footer-language > .language");
        FooterLanguageBlock.classList.remove("language-active");
      });
    }
    if (buttonHeaderCurrency) {
      buttonHeaderCurrency.addEventListener("click", function () {
        var FooterCurrencyBlock = document.querySelector(".js-header-currency > .currency");
        FooterCurrencyBlock.classList.toggle("currency-active");
        var HeaderLanguageBlock = document.querySelector(".js-header-language >.language");
        HeaderLanguageBlock.classList.remove("language-active");
      });
    }
    if (buttonMobilleCurrency) {
      buttonMobilleCurrency.forEach(function (item) {
        item.addEventListener("click", function () {
          var mobbileCurrencyBlock = document.querySelector(".currency-mob > .currency");
          mobbileCurrencyBlock.classList.add("currency-active");
          // Main.onShow()

          var languageBlock = document.querySelectorAll(".language-mob > .language");
          languageBlock.forEach(function (item) {
            item.classList.remove("language-active");
          });
        });
      });
    }
    $(document).on('click', '.currency-content-closed', function (e) {
      e.preventDefault();
      $('div.currency').removeClass('currency-active');
      // Main.onClose()
    });
  },

  language: function language() {
    var buttonMobilleLanguage = document.querySelectorAll(".js-language-mob");
    var buttonFooterLanguage = document.querySelector(".js-footer-language");
    var buttonHeaderLanguage = document.querySelector(".js-header-language");
    if (buttonFooterLanguage) {
      buttonFooterLanguage.addEventListener("click", function () {
        var FooterLanguageBlock = document.querySelector(".js-footer-language > .language");
        FooterLanguageBlock.classList.toggle("language-active");
        var FooterCurrencyBlock = document.querySelector(".js-footer-currency > .currency");
        FooterCurrencyBlock.classList.remove("currency-active");
      });
    }
    if (buttonHeaderLanguage) {
      buttonHeaderLanguage.addEventListener("click", function () {
        var HeaderLanguageBlock = document.querySelector(".js-header-language >.language");
        HeaderLanguageBlock.classList.toggle("language-active");
        var FooterCurrencyBlock = document.querySelector(".js-header-currency > .currency");
        FooterCurrencyBlock.classList.remove("currency-active");
      });
    }
    if (buttonMobilleLanguage) {
      buttonMobilleLanguage.forEach(function (item) {
        item.addEventListener("click", function () {
          var languageBlock = document.querySelectorAll(".language-mob > .language");
          languageBlock.forEach(function (item) {
            item.classList.add("language-active");
          });
          var mobbileCurrencyBlock = document.querySelector(".currency-mob > .currency");
          mobbileCurrencyBlock.classList.remove("currency-active");
        });
      });
    }
    $(document).on('click', '.language-content-closed', function (e) {
      e.preventDefault();
      $('div.language').removeClass('language-active');
      Main.onClose();
      console.log("12321");
    });
  },
  Fnaccordion: function Fnaccordion() {
    var accordion = document.querySelectorAll(".accordion");
    accordion.forEach(function (accordion) {
      accordion.addEventListener("click", function () {
        accordion.classList.toggle("accordion-active");
        var panel = accordion.nextElementSibling;
        panel.classList.toggle("active");
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          // panel.classList.remove("accordion-active")
          panel.style.maxHeight = panel.scrollHeight + "px";
          // panel.style.maxHeight = (panel.scrollHeight > 190 ? panel.scrollHeight : 190) + "px";
        }
      });
    });
  },

  ClosePopup: function ClosePopup() {
    var BtnClosed = document.querySelectorAll(".popup-closed");
    BtnClosed.forEach(function (item) {
      item.addEventListener("click", function (e) {
        item.parentNode.classList.remove("active");
      });
    });
  },
  PaymentCheck: function PaymentCheck() {
    var paymentCheckBlock = document.querySelector(".choose-method__content");
    if (paymentCheckBlock) {
      var CheckRbBank = document.getElementById("rbBank");
      var CheckRbPaypal = document.getElementById("rbPaypal");
      var BlockBank = document.querySelector(".choose-method__Bank");
      var BlockPaypal = document.querySelector(".choose-method__Paypal");
      var addBlockAnimationClass = function addBlockAnimationClass(removeClassBlock, addClassBlock) {
        return function () {
          if (!removeClassBlock.classList.contains("active-block")) {
            addClassBlock.classList.add("active-block");
            return;
          }
          removeClassBlock.classList.remove("active-block");
          setTimeout(function () {
            addClassBlock.classList.add("active-block");
          }, 1000);
        };
      };
      CheckRbBank.addEventListener('click', addBlockAnimationClass(BlockPaypal, BlockBank));
      CheckRbPaypal.addEventListener('click', addBlockAnimationClass(BlockBank, BlockPaypal));
    }
  },
  OpenCabinetMenu: function OpenCabinetMenu() {
    var OpenCabinetMenuCheck = document.querySelector(".my-menu");
    if (OpenCabinetMenuCheck) {
      var OpenMenuFn = document.querySelector(".my-menu__open");
      var ClosedMenuFn = document.querySelector(".my-menu__mobile-closed__icon");
      var MenuMobile = document.querySelector(".my-menu__mobile");
      OpenMenuFn.addEventListener("click", function () {
        MenuMobile.classList.add("my-menu__mobile-active");
        Main.onShow();
      });
      if (ClosedMenuFn) {
        ClosedMenuFn.addEventListener("click", function () {
          MenuMobile.classList.remove("my-menu__mobile-active");
          Main.onClose();
        });
      }
    }
  },
  FnHelpAccordion: function FnHelpAccordion() {
    var HelpAccordionCheck = document.querySelector(".help__accordion-accordion");
    if (HelpAccordionCheck) {
      var HelpAccordion = document.querySelectorAll(".help__accordion-accordion");
      HelpAccordion.forEach(function (accordion) {
        accordion.addEventListener("click", function () {
          accordion.classList.toggle("accordion-active");
          var panel = accordion.nextElementSibling;
          panel.classList.toggle("active");
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      });
    }
  },
  FnAccordion: function FnAccordion() {
    var blockAccordionCheck = document.querySelector(".block__accordion-accordion");
    if (blockAccordionCheck) {
      var blockAccordion = document.querySelectorAll(".block__accordion-accordion");
      blockAccordion.forEach(function (accordion) {
        accordion.addEventListener("click", function () {
          accordion.classList.toggle("accordion-active");
          var panel = accordion.nextElementSibling;
          panel.classList.toggle("active");
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
            panel.style.paddingBottom = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
            panel.style.paddingBottom = panel.scrollHeight + 20 + "px";
          }
        });
      });
    }
  },
  PopupLanguages: function PopupLanguages() {
    var LanguagesPopup = document.querySelector(".popup__languages-speak");
    if (LanguagesPopup) {
      var LanguagesAddBtn = document.querySelector(".languages__btn");
      var LanguagesCloseBtn = document.querySelector(".closed__item");
      LanguagesAddBtn.addEventListener("click", function () {
        LanguagesPopup.style.display = "flex";
        Main.onShow();
      });
      LanguagesCloseBtn.addEventListener("click", function () {
        LanguagesPopup.style.display = "none";
        Main.onClose();
      });
    }
  },
  fnMessagesTabs: function fnMessagesTabs() {
    var MessagesTabs = document.querySelector(".messages-tabs");
    if (MessagesTabs) {
      var MessagesItem = document.querySelectorAll(".tabs-item");
      var chatListCart = document.querySelectorAll(".chat__list-cart");
      chatListCart.forEach(function (itemCart) {
        var _itemCart$querySelect;
        itemCart === null || itemCart === void 0 || (_itemCart$querySelect = itemCart.querySelector(".modal-menu__toggle")) === null || _itemCart$querySelect === void 0 || _itemCart$querySelect.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          itemCart.querySelector(".chat__modal-menu").classList.toggle("chat__modal-active");
        });
      });
      var chatWindowblock = document.querySelectorAll(".chat__user");
      chatWindowblock.forEach(function (itemBlock) {
        itemBlock.querySelector(".chat__user-menu").addEventListener("click", function () {
          itemBlock.querySelector(".chat__user-modal").classList.toggle("chat__modal-active");
        });
      });
      MessagesItem.forEach(function (item, index) {
        item.addEventListener("click", function () {
          MessagesItem.forEach(function (item) {
            item.classList.remove("active");
          });
          var menuBlock = document.querySelector(".my-menu");
          item.classList.add("active");
          if (index === 0) {
            menuBlock.classList.remove('tab__menu');
            menuBlock.classList.add('tab__messages');
          }
          if (index === 1) {
            menuBlock.classList.remove('tab__messages');
            menuBlock.classList.add('tab__menu');
          }
        });
      });
      document.querySelectorAll(".chat__list-cart").forEach(function (item) {
        item.addEventListener("click", function () {
          document.querySelector(".messages__content").classList.remove("chat__list__active-mobile");
          document.querySelector(".messages__content").classList.add("messages__window-active");
        });
      });
      document.querySelectorAll(".back").forEach(function (item) {
        item.addEventListener("click", function () {
          document.querySelector(".messages__content").classList.remove("messages__window-active");
          document.querySelector(".messages__content").classList.add("chat__list__active-mobile");
        });
      });
    }
  },
  // password strength checker

  passwordStrengthChecker: function passwordStrengthChecker() {
    var state = false,
      password = $('.password-checked'),
      passwordStrength = $(".password-line__color"),
      passwordStrengthText = $(".password-status__text"),
      lowUpperCase = $(".password-check__icons--upper-case"),
      number = $(".password-check__icons--one-number"),
      specialChar = $(".password-check__icons--special-char"),
      eightChar = $(".password-check__icons--eight-character"),
      passwordFirst = $(".form-element__password-first"),
      passwordFirstConf = $(".form-element__password-conf"),
      passwordFirstLog = $(".form-element__password-log");
    password.bind("input", function () {
      var pass = password.val();
      checkStrength(pass);
    });
    passwordFirst.click(function () {
      if (state) {
        $("#signupform-password").attr("type", "password");
        state = false;
        $(this).find('.eye-off').css("opacity", "1");
        $(this).find('.eye-on').css("opacity", "0");
      } else {
        $("#signupform-password").attr("type", "text");
        state = true;
        $(this).find('.eye-off').css("opacity", "0");
        $(this).find('.eye-on').css("opacity", "1");
      }
    });
    passwordFirstConf.click(function () {
      if (state) {
        $("#signupform-passwordconfirm").attr("type", "password");
        state = false;
        $(this).find('.eye-off').css("opacity", "1");
        $(this).find('.eye-on').css("opacity", "0");
      } else {
        $("#signupform-passwordconfirm").attr("type", "text");
        state = true;
        $(this).find('.eye-off').css("opacity", "0");
        $(this).find('.eye-on').css("opacity", "1");
      }
    });
    passwordFirstLog.click(function () {
      if (state) {
        $("#loginform-password").attr("type", "password");
        state = false;
        $(this).find('.eye-off').css("opacity", "1");
        $(this).find('.eye-on').css("opacity", "0");
      } else {
        $("#loginform-password").attr("type", "text");
        state = true;
        $(this).find('.eye-off').css("opacity", "0");
        $(this).find('.eye-on').css("opacity", "1");
      }
    });
    function checkStrength(password) {
      var strength = 0;
      //If password contains both lower and uppercase characters
      if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
        strength += 1;
        lowUpperCase.children('.checked').css("opacity", "1");
        lowUpperCase.children('.close').css("opacity", "0");
      } else {
        lowUpperCase.children('.checked').css("opacity", "0");
        lowUpperCase.children('.close').css("opacity", "1");
      }
      //If it has numbers and characters
      if (password.match(/([0-9])/)) {
        strength += 1;
        number.children('.checked').css("opacity", "1");
        number.children('.close').css("opacity", "0");
      } else {
        number.children('.checked').css("opacity", "0");
        number.children('.close').css("opacity", "1");
      }
      // //If it has one special character
      if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) {
        strength += 1;
        specialChar.children('.checked').css("opacity", "1");
        specialChar.children('.close').css("opacity", "0");
      } else {
        specialChar.children('.checked').css("opacity", "0");
        specialChar.children('.close').css("opacity", "1");
      }
      // //If password is greater than 7
      if (password.length > 7) {
        strength += 1;
        eightChar.children('.checked').css("opacity", "1");
        eightChar.children('.close').css("opacity", "0");
      } else {
        eightChar.children('.checked').css("opacity", "0");
        eightChar.children('.close').css("opacity", "1");
      }

      // If value is less than 2
      if (strength < 2) {
        passwordStrength.removeClass('line_average');
        passwordStrength.removeClass('line_excellent');
        passwordStrength.addClass('line_low');
        passwordStrength.style = 'width: 10%';
        $(".password-status__text.excellent").removeClass('active');
        $(".password-status__text.average").removeClass('active');
        $(".password-status__text.low").addClass('active');
      } else if (strength === 3) {
        passwordStrength.removeClass('line_excellent');
        passwordStrength.removeClass('line_low');
        passwordStrength.addClass('line_average');
        passwordStrength.style = 'width: 60%';
        $(".password-status__text.excellent").removeClass('active');
        $(".password-status__text.low").removeClass('active');
        $(".password-status__text.average").addClass('active');
      } else if (strength === 4) {
        passwordStrength.removeClass('line_average');
        passwordStrength.removeClass('line_low');
        passwordStrength.addClass('line_excellent');
        passwordStrength.style = 'width: 100%';
        $(".password-status__text.average").removeClass('active');
        $(".password-status__text.low").removeClass('active');
        $(".password-status__text.excellent").addClass('active');
      }
    }
  },
  dynamicCounter: function dynamicCounter() {
    $('.dynamic-counter__number').each(function () {
      $(this).prop('Counter', 0).animate({
        Counter: $(this).text()
      }, {
        duration: 4000,
        easing: 'swing',
        step: function step(now) {
          $(this).text(Math.ceil(now));
        }
      });
    });
  },
  checkedBackground: function checkedBackground() {
    $('#form-onboarding__checked-all').change(function () {
      if ($(this).find("input").is(':checked')) {
        $(this).css("background", "#1F3470");
      } else {
        $(this).css("background", "#E0E0E0");
      }
    });
    $(document).ready(function () {
      $(".form-onboarding__checked-this input").each(function () {
        if (this.checked) {
          $(this).parent().css("background", "#1F3470");
        } else {
          $(this).parent().css("background", "#E0E0E0");
        }
      });
      $("#form-onboarding__checked-all input").change(function () {
        if (this.checked) {
          $(".form-onboarding__checked-this input").each(function () {
            this.checked = true;
            $(this).parent().css("background", "#1F3470");
          });
        } else {
          $(".form-onboarding__checked-this input").each(function () {
            this.checked = false;
            $(this).parent().css("background", "#E0E0E0");
          });
        }
      });
      $(".form-onboarding__checked-this input").on('click', function () {
        if ($(this).is(":checked")) {
          var isAllChecked = 0;
          $(this).parent().css("background", "#1F3470");
          $(".form-onboarding__checked-this input").each(function () {
            if (!this.checked) {
              isAllChecked = 1;
            }
          });
          if (isAllChecked == 0) {
            $("#form-onboarding__checked-all input").prop("checked", true);
            $("#form-onboarding__checked-all input").parent().css("background", "#1F3470");
          }
        } else {
          $("#form-onboarding__checked-all input").prop("checked", false);
          $("#form-onboarding__checked-all input").parent().css("background", "#E0E0E0");
          $(this).parent().css("background", "#E0E0E0");
        }
      });
    });
  },
  showDashboardContent: function showDashboardContent() {
    $('.dashboard__profile-p').on('click', function () {
      $(this).addClass('active');
      $('.profile').addClass("active");
      $('.dashboard__profile-r').removeClass("active");
      $('.reviews').removeClass("active");
    });
    $('.dashboard__profile-r').on('click', function () {
      $(this).addClass('active');
      $('.reviews').addClass("active");
      $('.dashboard__profile-p').removeClass("active");
      $('.profile').removeClass("active");
    });
    $('.profile-user__rating').on('click', function () {
      $('.dashboard__profile-r').addClass('active');
      $('.reviews').addClass("active");
      $('.dashboard__profile-p').removeClass("active");
      $('.profile').removeClass("active");
      if (window.matchMedia("(min-width: 992px)").matches) {} else {
        $("html, body").animate({
          scrollTop: $(".reviews").offset().top
        }, 1500);
      }
    });
  },
  handleClick: function handleClick() {
    $('.header-desc-account').on('click', function () {
      $('.header-desc-account__popup').toggleClass('active');
    });
    $(document).mouseup(function (e) {
      var div = $(".header-desc-account__popup");
      if (!div.is(e.target) && div.has(e.target).length === 0) {
        div.removeClass('active');
      }
    });
    $('.hamburger-account-user').on('click', function () {
      $('.hamburger-account--popup').toggleClass('active-mob');
    });
    $('.close-popup').on('click', function (event) {
      event.preventDefault();
      $('.pop-up').removeClass('active');
    });
  },
  scrollToBottom: function scrollToBottom() {
    $('.chat__container').animate({
      scrollTop: $(document).height()
    });
    $('.chat__list-content').animate({
      scrollTop: $(document).height()
    });
  },
  emojionearea: function emojionearea() {
    // new EmojiPicker({
    //   trigger: [
    //       {
    //           selector: '.messages-smile',
    //           insertInto: ['.messages__send'] // '.selector' can be used without array
    //       },
    //       // {
    //       //     selector: '.second-btn',
    //       //     insertInto: '.two'
    //       // }
    //   ],
    //   closeButton: true
    // });
  },
  changeCounterColor: function changeCounterColor(colorBlock, value, yellow, red) {
    if (value < yellow) {
      colorBlock.removeClass('red');
      colorBlock.removeClass('yellow');
      colorBlock.addClass('green');
    }
    if (value >= yellow && value < red) {
      colorBlock.removeClass('red');
      colorBlock.removeClass('green');
      colorBlock.addClass('yellow');
    }
    if (value >= red) {
      colorBlock.removeClass('green');
      colorBlock.removeClass('yellow');
      colorBlock.addClass('red');
    }
  },
  textareaAutoHeight: function textareaAutoHeight() {
    $('.messages__send').on('keyup', function () {
      $(this).style.height = 'auto';
      $(this).style.height = $(this).scrollHeight + 'px';
    });
  },
  showTips: function showTips() {
    // need rewrite
    $('.offer__btn').on('click', function () {
      $('.offer__tips').slideDown();
      $('.offer__tips').css('top', '80px');
      $("html,body").css("overflow", "hidden");
      $('.offer__tips').css('display', 'block');
    });
    $('.offer__btn').on('click', function () {
      $('.offer__tips').css('display', 'block');
    });
    $('.offer__closed').on('click', function () {
      $('.offer__tips').slideToggle();
      $('.offer__tips').css('top', '0');
      $("html,body").css("overflow", "visible");
    });
  },
  selectToStep: function selectToStep() {
    $('.select-new__btn').on('click', function () {
      if ($(this).closest('.select-new').find('.select-new__info').hasClass("select-new__info--active")) {
        $('.select-new__selects').slideUp("hide");
        $('.select-new__info').removeClass("select-new__info--active");
      } else {
        $(this).closest('.select-new').find('.select-new__selects').slideDown("show");
        $(this).closest('.select-new').find('.select-new__info').addClass("select-new__info--active");
      }
      $('.select-new__btn').addClass("disable");
      $(this).removeClass("disable");
      if ($(".select-new__btn").hasClass('disable')) {
        $('.disable').closest('.select-new').find('.select-new__selects').slideUp("hide");
        $('.disable').closest('.select-new').find('.select-new__info').removeClass("select-new__info--active");
      }
      var items = $(this).closest('.select-new').find('.select-new__select');
      items.each(function (index, item) {
        item.addEventListener('click', function () {
          $(this).closest('.select-new').find('.select-new__info').text(item.textContent);
          $(this).closest('.select-new').find('.select-new__info').addClass('select-new__info--color');
          var _iterator = _createForOfIteratorHelper(items),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var i = _step.value;
              i.classList.remove('select-new__select--active');
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          items[index].classList.add('select-new__select--active');
          var dataId = item.getAttribute('data-id');
          $(this).closest('.select-new').find('input').attr('value', dataId);
          $('.select-new__selects').slideUp("hide");
          $('.select-new__info').removeClass("select-new__info--active");
        });
      });
    });
    $(document).on('click', function (e) {
      if (!$(e.target).closest(".select-new__btn").length) {
        $('.select-new__selects').slideUp("hide");
        $('.select-new__info').removeClass("select-new__info--active");
      }
      e.stopPropagation();
    });
  },
  showHoverPopup: function showHoverPopup() {
    $(".form-step__info").mouseover(function () {
      $(this).find('.popup').show();
    }).mouseout(function () {
      $(this).find('.popup').hide();
    });
    $(".alert__info").mouseover(function () {
      $(this).find('.popup').show();
    }).mouseout(function () {
      $(this).find('.popup').hide();
    });
    $(document).on('click', function (e) {
      if (!$(e.target).closest(".form-step__info").length) {
        $(".form-step__info").find('.popup').css("display", "none");
      }
      e.stopPropagation();
    });
  },
  checkedShowTextarea: function checkedShowTextarea() {
    $('.form-step__radio').change(function () {
      if ($('#r4d').is(':checked')) {
        $('#radiodDays').css("display", "block");
      } else {
        $('#radiodDays').css("display", "none");
      }
      if ($('#r8d').is(':checked')) {
        $('#radiodHours').css("display", "block");
      } else {
        $('#radiodHours').css("display", "none");
      }
    });
  },
  showPreloader: function showPreloader(button) {
    Main.buttonBody = button.html();
    button.prop('disabled', true);
    button.html('<div id="btn-preloader"></div>');
  },
  hidePreloader: function hidePreloader(button) {
    var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    setTimeout(function () {
      button.prop('disabled', disabled);
      button.html(Main.buttonBody);
    }, 750);
  },
  toggleShowMenu: function toggleShowMenu() {
    $('.my-services__toggle, .my-services__close').click(function () {
      $('.my-services__menu').toggleClass('active');
    });
  },
  selectTransportsPopup: function selectTransportsPopup() {
    $('.select-transports__btn').on('click', function () {
      if (window.matchMedia("(max-width: 991px)").matches) {
        document.body.style.overflowY = 'hidden';
      } else {
        document.body.style.overflowY = 'visible';
      }
      $('.select-transports__pop-up').toggleClass('active');
      $(this).toggleClass('active');
    });
    $('.select-transports__close').on('click', function () {
      document.body.style.overflowY = 'visible';
      $('.select-transports__pop-up').removeClass('active');
      $('.select-transports__btn').removeClass('active');
    });
  },
  homeTabs: function homeTabs() {
    // need rewrite
    $('.home-block__tab').on('click', function () {
      $('.home-block__tab').removeClass('active');
      $(this).addClass('active');
      if ($('.client').hasClass('active')) {
        $('.client-block').show();
        $('.service-provider-block').hide();
        $('.business-block').hide();
        if ($(window).width() <= '992') {
          $('.hero_right-client').show();
          $('.hero_right-service').hide();
          $('.hero_right-business').hide();
        } else {
          $('.hero_right-client').show(500);
          $('.hero_right-service').hide(500);
          $('.hero_right-business').hide(500);
        }
      }
      if ($('.service-provider').hasClass('active')) {
        $('.service-provider-block').show();
        $('.client-block').hide();
        $('.business-block').hide();
        if ($(window).width() <= '992') {
          $('.hero_right-service').show();
          $('.hero_right-client').hide();
          $('.hero_right-business').hide();
        } else {
          $('.hero_right-service').show(500);
          $('.hero_right-client').hide(500);
          $('.hero_right-business').hide(500);
        }
      }
      if ($('.business').hasClass('active')) {
        $('.business-block').show();
        $('.client-block').hide();
        $('.service-provider-block').hide();
        if ($(window).width() <= '992') {
          $('.hero_right-business').show();
          $('.hero_right-client').hide(0);
          $('.hero_right-service').hide(0);
        } else {
          $('.hero_right-business').show(500);
          $('.hero_right-client').hide(500);
          $('.hero_right-service').hide(500);
        }
      }
    });
  },
  newHeader: function newHeader() {
    $('.header-account__btn').on('click', function () {
      $(this).next().toggle();
    });
    $(document).on('click', function (e) {
      if (!$(e.target).parents('.header-account').length) {
        $(".header-account__items").hide();
      }
    }).on('click', function (e) {
      if (!$(e.target).parents('.main-nav__inner').length) {
        $(".main-nav__items ").removeClass('active');
        $(".main-nav__btn ").removeClass('active');
      }
    });
    $('.main-nav__btn').on('click', function () {
      $('.main-nav__btn').removeClass('active');
      $('.main-nav__items').removeClass('active');
      $(this).next().toggleClass('active');
      $(this).toggleClass('active');
    });
    $('.toggle-menu').on('click', function () {
      $(this).toggleClass('active');
      $('.new-header__container').toggleClass('active');
      document.querySelector('body').classList.toggle('body-hidden');
      // $('body').toggleClass('body-hidden');
    });

    $('.new-header__language').on('click', function () {
      $('.language').toggleClass('language-active');
    });
    $('.footer-option-item--language').on('click', function () {
      $('.language').addClass('language-active');
      console.log("sdqd");
    });
    $(document).on('click', function (e) {
      if (!$(e.target).parents('.new-header__block').length) {
        $('.language-header-block').find(".language ").removeClass('language-active');
      }
    }).on('click', function (e) {
      if (!$(e.target).parents('.new-footer-block').length) {
        $('.language-footer-block').find(".language ").removeClass('language-active');
      }
    });
    if ($('.onboarding-language').hasClass('active-onboarding')) {
      $(document).on('click', function (e) {
        if (!$(e.target).parents('.onboarding-language__block').length) {
          $(".language ").removeClass('language-active');
        }
      });
    }
  },
  menuOpenNew: function menuOpenNew() {
    $('.btn__open--new').on('click', function () {
      $('.my-menu--new').addClass('active');
    });
    $('.my-menu__closed').on('click', function () {
      $('.my-menu--new').removeClass('active');
    });
  },
  initUserPhotoCropper: function initUserPhotoCropper() {
    var $image = $('#image-cropper');
    $image.cropper({
      aspectRatio: 1,
      viewMode: 1,
      crop: function crop(event) {}
    });
    var cropper = $image.data('cropper');
  },
  preloaderProfilePopUp: function preloaderProfilePopUp(event, preloderCount) {
    var preloaderWrapper = $('.edit-image__preloader');
    var set;
    if (preloderCount) {
      setInterval(fakePreloader, 700);
    }
    function fakePreloader() {
      if (preloderCount) {
        preloaderWrapper.css('display', "flex");
      } else {
        clearInterval(set);
        preloaderWrapper.hide();
      }
    }
  },
  hoverActiveCart: function hoverActiveCart() {
    $(document).on('click', function (event) {
      if (!$(event.target).closest('.help-carts__items').length) {
        $('.help-carts__item.active').removeClass('active');
      }
    });
    $('.help-carts__items').on('click', '.help-carts__item', function () {
      if ($(this).hasClass('second')) {
        $('.new-calculator').show();
        $([document.documentElement, document.body]).animate({
          scrollTop: $(".new-calculator").offset().top - 90
        }, 1500);
      }
      $('.help-carts__item.active').removeClass('active');
      $(this).addClass('active');
    });
  },
  scrollToPartners: function scrollToPartners() {
    $(".button-scroll").click(function () {
      $([document.documentElement, document.body]).animate({
        scrollTop: $(".partners__contact").offset().top
      }, 1500);
    });
  },
  ajax: {
    obj: {},
    url: AJAX_URL,
    send: function send(success, failure) {
      var _this = this;
      $.post(this.url, this.obj, function (answer) {
        _this.obj = {};
        answer.result && typeof success === 'function' ? success(answer) : !answer.result && typeof failure === 'function' ? failure(answer) : null;
      }, 'JSON');
    },
    sendAnswerOnQuestionAboutWhereYouFoundCompany: function sendAnswerOnQuestionAboutWhereYouFoundCompany(btn, answer) {
      this.obj.method = 'sendAnswerOnQuestionAboutWhereYouFoundCompany';
      this.obj.answer = answer;
      this.send(function (result) {
        $('.answer-question-coupon').removeClass('active');
        Main.hidePreloader(btn);
      }, function (result) {
        Main.hidePreloader(btn);
      });
    },
    turnOnAutoTranslations: function turnOnAutoTranslations(button, language) {
      this.obj.method = 'turnOnAutoTranslations';
      this.obj.language = language;
      this.send(function () {
        $('.choose-language--popup').removeClass('active');
        if (button.hasAttr('data-action')) {
          if (button.attr('data-action') === '1') {
            if (Messages.isMiniChat) {
              Messages.ajax.openMiniChatViaHash(Messages.chatID);
            } else {
              $('div.chat__list__item.active').click();
            }
          }
        } else {
          setTimeout(function () {
            window.location.reload();
          }, 350);
        }
      });
    },
    translateText: function translateText(button, element, text, language) {
      this.obj.method = 'translateText';
      this.obj.text = text;
      this.obj.language = language;
      this.send(function (answer) {
        var translation = answer.translation.replaceAll("\n", "<br>");
        $("[data-translate-id=\"".concat(element, "\"]")).html(translation);
        button.addClass('hide-translation').find('p').text(button.attr('data-text-stage-2'));
      });
    },
    generalPopupsClose: function generalPopupsClose(link, id) {
      this.obj.method = 'generalPopupsClose';
      this.obj.id = id;
      this.send(function (answer) {
        if (link.length > 0) window.location.replace(link);
      });
    },
    reminerGeneralPopups: function reminerGeneralPopups(id) {
      this.obj.method = 'reminerGeneralPopups';
      this.obj.id = id;
      this.send(function (answer) {
        $('.general-popup-main').removeClass('active');
      });
    },
    getPartnersList: function getPartnersList(category) {
      this.obj.method = 'getPartnersList';
      this.obj.category = category;
      this.send(function (answer) {
        $('#eco-system-slider').html(answer.html);
        new Swiper('.eco-system-content', {
          lazy: true,
          wrapperClass: "eco-system-wrapper",
          slideClass: "eco-system-slide",
          slidesPerView: 1,
          // loop: true,
          spaceBetween: 20,
          breakpoints: {
            600: {
              slidesPerView: 2
            },
            992: {
              slidesPerView: 3
            }
          },
          pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true,
            dynamicMainBullets: 1
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        });
      });
    },
    closeAccountFillingInfoBlock: function closeAccountFillingInfoBlock() {
      this.obj.method = 'closeAccountFillingInfoBlock';
      this.send(function () {});
    },
    openServiceInfoPopup: function openServiceInfoPopup(title, desc, img) {
      this.obj.method = 'openServiceInfoPopup';
      this.obj.title = title;
      this.obj.desc = desc;
      this.obj.img = img;
      this.send(function (answer) {
        $('.service-pop-up').removeClass('not-active').addClass('active');
        $('.service-pop-up__wrapper').html(answer.html);
      });
    },
    calculateMove: function calculateMove(tab, from, to, type, lat, lng, countryFrom, countryTo) {
      this.obj.method = 'calculateMove';
      this.obj.tab = tab;
      this.obj.from = from;
      this.obj.to = to;
      this.obj.type = type;
      this.obj.lat = lat;
      this.obj.lng = lng;
      this.obj.countryFrom = countryFrom;
      this.obj.countryTo = countryTo;
      this.send(function (answer) {
        var activeTab = tab;
        if (answer.showBlock) {
          $('.calculator-bl__total').css('display', 'flex');
          $("#calculator-total-amount").text(answer.amount);
          $('.calculator-bl__submit').css('display', 'flex').attr('href', answer.link);
        } else {
          $('.calculator-bl__total').hide();
          $('.calculator-bl__submit').hide();
          activeTab = 0;
        }
        $('.calculator-bl__text').hide();
        $(".calculator-bl__text[data-tab=\"".concat(activeTab, "\"]")).css('display', 'flex');
      });
    },
    trackingLinkClickInterception: function trackingLinkClickInterception(link) {
      this.obj.method = 'trackingLinkClickInterception';
      this.send(function () {
        setTimeout(function () {
          window.open(link, '_blank');
        });
      }, function () {
        setTimeout(function () {
          window.open(link, '_blank');
        });
      });
    }
  },
  whatMoveAccordion: function whatMoveAccordion() {
    var whatMoveCheck = document.querySelector(".what-move");
    if (whatMoveCheck) {
      var whatMoveAccordion = document.querySelectorAll(".what-move-accordion");
      whatMoveAccordion.forEach(function (accordion) {
        accordion.addEventListener("click", function (e) {
          whatMoveAccordion.forEach(function (item) {
            if (item !== e.currentTarget) {
              item.classList.remove("accordion-active");
              var _panel = item.querySelector('.what-move-panel');
              _panel.classList.remove("active");
              _panel.style.maxHeight = 0 + "px";
            }
          });
          accordion.classList.toggle("accordion-active");
          var panel = accordion.querySelector('.what-move-panel');
          panel.classList.add("active");
          if (panel.style.maxHeight && parseInt(panel.style.maxHeight) !== 0) {
            panel.style.maxHeight = null;
            panel.style.maxHeight = 0 + "px";
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      });
    }
  }
};
function show_hide_password() {
  // need rewrite
  var inputPasswordIcon = document.querySelectorAll('.form-element__password');
  inputPasswordIcon.forEach(function (item, index) {
    item.addEventListener("click", function () {
      var input = item.previousSibling.previousSibling;
      if (input.getAttribute('type') == 'password') {
        input.setAttribute('type', 'text');
        item.querySelector(".password-off").style.display = "none";
        item.querySelector(".password-on").style.display = "block";
        item.querySelector(".password-on").style.opacity = "1";
      } else {
        input.setAttribute('type', 'password');
        item.querySelector(".password-off").style.display = "block";
        item.querySelector(".password-on").style.display = "none";
        item.querySelector(".password-on").style.opacity = "0";
      }
    });
  });
}
show_hide_password(); // need rewrite

$(document).ready(function () {
  // need rewrite
  $('.js-example-basic-single').select2();
});
$(document).ready(function () {
  // need rewrite
  $('.js-example-basic-single2').select2();
});
$(function () {
  // need rewrite
  $(".emails").inputmask("email");
});
var customSelect = document.querySelector(".select"); // need rewrite | translate comments PLEASE!
if (customSelect) {
  document.querySelectorAll('.select').forEach(function (select) {
    //Выбриаем все выпадающие списки на странице

    var selectCurrent = select.querySelector('.select__current');
    if (selectCurrent) {
      var selectList = select.querySelector('.select__list');
      var selectInput = select.querySelector('.select__input');
      var selectItem = select.querySelectorAll('.select__item');

      //по клику добавляем/удалям класс
      selectCurrent.addEventListener('click', function () {
        selectList.classList.toggle('show');
      });

      //обходим элементы списка
      selectItem.forEach(function (item) {
        //обрабатываем событие клик по элементу
        item.addEventListener('click', function () {
          //получаем значение из data-атрибута
          var itemValue = item.getAttribute('data-value');

          //получаем содержание элемента (текст)
          var itemText = item.textContent;

          //присваиваем инпуту ранее полученное значение из data-атрибута
          selectInput.value = itemValue;

          //присваиваем текущее значение (текст)
          selectCurrent.textContent = itemText;
          $('.select__list').next().find('p').hide();

          //скрываем выпадающий список
          selectListHide();
          if (document.querySelector(".business-page") || document.querySelector(".business-seo")) {
            selectCurrent.classList.add('while');
          }
        });
      });

      // функция закрытия выпадающего списка
      var selectListHide = function selectListHide() {
        selectList.classList.remove('show');
        // $('.error').hide();
      };

      //Закрываем выпадающий сисок, если клик был вне области
      document.addEventListener('mouseup', function (e) {
        if (!select.contains(e.target)) selectListHide();
      });
    }
  });
}
$('.popup-closed__contact-us').on('click', function () {
  $('#contact-us-thanks-popup').hide();
});

// let videoAbout = document.querySelector("#aboutUsVideo")
// if (videoAbout) {
//     document.querySelector(".video-play").addEventListener("click", function () {
//         videoAbout.setAttribute("controls", "controls")
//         videoAbout.play();
//         document.querySelector(".video-play").style.display = "none"
//     })
// }

var langSelect = document.querySelectorAll(".select-driver__select"); // need rewrite
var langBlock = document.querySelectorAll(".languages__block__item");
if (langSelect && langBlock) {
  langSelect.forEach(function (item, index) {
    item.querySelector("input").addEventListener("click", function () {
      if (item.querySelector("input").checked == true) {
        langBlock.forEach(function (item2, index2) {
          if (index === index2) {
            item2.style.display = "flex";
          }
        });
      }
    });
  });
  langBlock.forEach(function (item, idx) {
    item.querySelector("button").addEventListener("click", function (e) {
      e.preventDefault();
      item.style.display = "none";
      langSelect.forEach(function (item2, idx2) {
        if (idx === idx2) {
          item2.querySelector("input").checked = false;
        }
      });
    });
  });
}
var findHelpTab = document.querySelectorAll('.find-help-list-item');
var findHelpContent = document.querySelectorAll('.content-item');
if (findHelpTab && findHelpContent) {
  findHelpTab.forEach(function (tabItem, tabIdx) {
    tabItem.addEventListener('click', function () {
      findHelpTab.forEach(function (item) {
        item.classList.remove('active');
      });
      tabItem.classList.add('active');
      findHelpContent.forEach(function (contentItem, contentIdx) {
        contentItem.classList.remove('active');
        if (tabIdx == contentIdx) {
          contentItem.classList.add('active');
        }
      });
    });
  });
}
var textBlock = document.querySelectorAll(".list"); // need rewrite
if (textBlock) {
  textBlock.forEach(function (item, idx) {
    var cropElement = item.querySelector('.crop-text');
    var showMore = item.querySelector(".show-more");
    var lessMore = item.querySelector(".less-more");
    var saveText = cropElement.innerHTML;
    var text = cropElement.innerHTML;
    var sizeText = 150;
    var endCharacter = '...';
    lessMore.style.display = "none";
    if (cropElement.innerHTML.length > sizeText) {
      text = text.substr(0, sizeText);
      cropElement.innerHTML = text + endCharacter;
    } else {
      showMore.style.display = "none";
    }
    showMore.addEventListener("click", function () {
      cropElement.innerHTML = saveText;
      showMore.style.display = "none";
      lessMore.style.display = "block";
    });
    lessMore.addEventListener("click", function () {
      text = text.substr(0, sizeText);
      cropElement.innerHTML = text + endCharacter;
      showMore.style.display = "block";
      lessMore.style.display = "none";
    });
  });
}
var ourLocations = document.querySelector(".our-locations"); // need rewrite
if (ourLocations) {
  var ourLocationsNation = document.querySelectorAll(".our-locations-nation > p");
  ourLocationsNation.forEach(function (item, idx) {
    item.addEventListener("click", function () {
      ourLocationsNation.forEach(function (item) {
        item.classList.remove("active");
      });
      item.classList.add("active");
      var ourLocationsBackyard = document.querySelectorAll(".our-locations-backyard");
      ourLocationsBackyard.forEach(function (itemBackyard, idxBackyard) {
        if (idx == idxBackyard) {
          ourLocationsBackyard.forEach(function (item) {
            item.classList.remove("active");
          });
          itemBackyard.classList.add("active");
        }
      });
    });
  });
}
var firstPopup = document.querySelector(".first-popup"); // need rewrite
if (firstPopup) {
  firstPopup.querySelector(".first-popup__closed").addEventListener("click", function () {
    firstPopup.classList.remove("active");
  });
}
var helpQuick = document.querySelector('.help-quick__popup');
var tag = document.createElement('script');
tag.src = "//www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var player;
if (helpQuick) {
  document.querySelector('.video-play').addEventListener('click', function () {
    helpQuick.style.display = "flex";
  });
  document.querySelector('.help-quick__close').addEventListener('click', function () {
    helpQuick.style.display = "none";
    function onYouTubeIframeAPIReady() {
      player = new YT.Player('muteVideoYoutube', {
        events: {
          'onReady': onPlayerReady
        }
      });
    }
    onYouTubeIframeAPIReady();
    function onPlayerReady() {
      player.mute();
      // console.log(player)
      player.stopVideo();
    }

    // var youtubePlayer = document.getElementsByClassName('help-quick__video')[0];
    // console.log(youtubePlayer)
    // youtubePlayer.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
    // $('.help-quick__video').each(function () {
    //     this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*')
    // });
  });
}

// let targetBlank = document.querySelector(".target-blank")
// if (targetBlank) {
//     targetBlank.addEventListener("click", function () {
//         targetBlank.classList.toggle('active')
//         // document.querySelector(".target-blank__popup").style.display = "flex"
//     })
//     document.querySelector(".target-blank__popup").addEventListener('mouseleave', function () {
//         // document.querySelector(".target-blank__popup").style.display = "none"
//         targetBlank.classList.remove('active')
//     })
// }

var targetBlank = document.querySelector(".target-blank");
if (targetBlank) {
  var targetToolTip = document.querySelector(".target-blank-tooltip");
  var targetToolTipClose = document.querySelector(".target-blank-tooltip-close");
  targetBlank.addEventListener("click", function () {
    targetToolTip.classList.add('active');
  });
  targetToolTipClose.addEventListener("click", function () {
    targetToolTip.classList.remove('active');
  });
}
var arrowscroll = document.querySelector(".target-blank__arrow");
if (arrowscroll) {
  arrowscroll.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
}
var popupRefisterTravel = document.querySelector(".register-travel-popup-body");
if (popupRefisterTravel) {
  document.querySelector(".register-travel-close").addEventListener("click", function () {
    document.querySelector(".register-travel-popup-body").classList.remove("active");
  });
}
var popupNotificationAlerts = document.querySelector(".notification-alerts-popup");
if (popupNotificationAlerts) {
  document.querySelector(".notification-alerts__close").addEventListener("click", function () {
    popupNotificationAlerts.classList.remove("active");
  });
}
var popupDownloadOffer = document.querySelector(".download-offer-popup");
if (popupDownloadOffer) {
  document.querySelector(".download-offer-close").addEventListener("click", function () {
    popupDownloadOffer.classList.remove("active");
  });
}
var profileSser = document.querySelector(".profile-user");
if (profileSser) {
  var checkedTool = document.querySelectorAll('.checked');
  checkedTool.forEach(function (item) {
    item.addEventListener('mouseout', function () {
      item.querySelector('.checked-tooltips').style.display = "none";
    });
  });
}
var howMuchPopup = document.querySelector(".how-much-popup");
if (howMuchPopup) {
  var howMuchPopupClose = howMuchPopup.querySelector('.how-much-popup__close');
  howMuchPopupClose.addEventListener('click', function () {
    howMuchPopup.style.display = 'none';
  });
  document.querySelector(".bonus-progress-btn").addEventListener('click', function () {
    howMuchPopup.style.display = 'flex';
  });
}
var popupInfoBonus = document.querySelector(".history-bonus");
if (popupInfoBonus) {
  var openPopupInfoBonus = document.querySelector('.bonus-history__btn');
  if (openPopupInfoBonus) {
    var closePopupInfoBonus = document.querySelector('.history-bonus__close');
    openPopupInfoBonus.addEventListener('click', function () {
      popupInfoBonus.classList.add('active');
    });
    closePopupInfoBonus.addEventListener('click', function () {
      popupInfoBonus.classList.remove('active');
    });
  }
}
var needFastOffer = document.querySelector(".need-fast-offer");
if (needFastOffer) {
  needFastOffer.querySelector('.closed').addEventListener('click', function () {
    needFastOffer.classList.remove('active');
  });
}
var needFastOfferDone = document.querySelector(".need-fast-offer-done");
if (needFastOfferDone) {
  needFastOfferDone.querySelector('.closed').addEventListener('click', function () {
    needFastOfferDone.classList.remove('active');
  });
}
var newOfferYourTask = document.querySelector(".new-offer-your_task");
if (newOfferYourTask) {
  newOfferYourTask.querySelector('.closed').addEventListener('click', function () {
    newOfferYourTask.classList.remove('active');
  });
}
var newBookingRequesTask = document.querySelector(".new-booking-reques_task");
if (newBookingRequesTask) {
  newBookingRequesTask.querySelector('.closed').addEventListener('click', function () {
    newBookingRequesTask.classList.remove('active');
  });
}
var messageSentPopup = document.querySelector(".message-sent");
if (messageSentPopup) {
  messageSentPopup.querySelector('.message-sent-close').addEventListener('click', function () {
    messageSentPopup.classList.remove('active');
  });
}
var businessPopupThank = document.querySelector(".popup-thank");
if (businessPopupThank) {
  businessPopupThank.querySelector('.popup-thank-close').addEventListener('click', function () {
    businessPopupThank.classList.remove('active');
  });
  businessPopupThank.querySelector('#popup-thank-close').addEventListener('click', function () {
    businessPopupThank.classList.remove('active');
  });
}

// let choosePlanPopup = document.querySelector(".choose-plan")
// if (choosePlanPopup) {
//     choosePlanPopup.querySelector('.choose-plan__close').addEventListener('click',function () {
//         choosePlanPopup.classList.remove('active')
//     })
// }

var addReviewsProfilePopup = document.querySelector(".add-reviews-profile--popup");
if (addReviewsProfilePopup) {
  addReviewsProfilePopup.querySelector('.add-reviews-profile--close').addEventListener('click', function () {
    addReviewsProfilePopup.classList.remove('active');
  });
}
var addReviewsProfileTwoPopup = document.querySelector(".add-reviews-profile--two--popup");
if (addReviewsProfileTwoPopup) {
  addReviewsProfileTwoPopup.querySelector('.add-reviews-profile--two--close').addEventListener('click', function () {
    addReviewsProfileTwoPopup.classList.remove('active');
  });
}
var reviewsAddedPopups = document.querySelectorAll(".reviews-added--popup");
reviewsAddedPopups.forEach(function (popup) {
  var closeBtn = popup.querySelector('.reviews-added--close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      popup.classList.remove('active');
    });
  }
});
var wantToQuitPopup = document.querySelector(".want-to-quit--popup");
if (wantToQuitPopup) {
  wantToQuitPopup.querySelector('.want-to-quit--popup--close').addEventListener('click', function () {
    wantToQuitPopup.classList.remove('active');
  });
}

// let anotherTaskPopup = document.querySelector(".another-task--popup")
// if (anotherTaskPopup) {
//     anotherTaskPopup.querySelector('.another-task--popup--close').addEventListener('click',function () {
//         anotherTaskPopup.classList.remove('active')
//     })
// }

var showTaskInPopup = document.querySelector(".show-task-in--popup");
if (showTaskInPopup) {
  showTaskInPopup.querySelector('.show-task-in--close').addEventListener('click', function () {
    showTaskInPopup.classList.remove('active');
  });
}
var whichTaskOffer = document.querySelector(".which-task-offer--popup");
if (whichTaskOffer) {
  var whichTaskOfferClose = whichTaskOffer.querySelector('.which-task-offer--close');
  if (whichTaskOfferClose) {
    whichTaskOfferClose.addEventListener('click', function () {
      whichTaskOffer.classList.remove('active');
    });
  }
}
var whichLocationServe = document.querySelector(".which-location-serve--popup");
if (whichLocationServe) {
  var whichLocationServeClose = whichLocationServe.querySelector('.which-location-serve--close');
  if (whichLocationServeClose) {
    whichLocationServeClose.addEventListener('click', function () {
      whichLocationServe.classList.remove('active');
    });
  }
}
var shallSaveSelection = document.querySelector(".shall-save-selection--popup");
if (shallSaveSelection) {
  shallSaveSelection.querySelector('.shall-save-selection--close').addEventListener('click', function () {
    shallSaveSelection.classList.remove('active');
  });
}
var billingHistory = document.querySelector(".billing-history--popup");
if (billingHistory) {
  billingHistory.querySelector('.billing-history--close').addEventListener('click', function () {
    billingHistory.classList.remove('active');
  });
}

// let stayOnPlanPopups = document.querySelectorAll(".stay-on-plan--popup");
//
// stayOnPlanPopups.forEach(function(popup) {
//     let closeBtns = popup.querySelectorAll('.stay-on-plan--closed');
//     closeBtns.forEach(function(btn) {
//         btn.addEventListener('click', function () {
//             popup.classList.remove('active');
//         });
//     });
// });

var planPayedPopup = document.querySelector(".plan-payed-success--popup");
if (planPayedPopup) {
  var closeBtn = planPayedPopup.querySelector('.plan-payed-success--popup__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      planPayedPopup.classList.remove('active');
    });
  }
}
var confirmOpenOffersPopup = document.querySelector(".confirm-open-offers--popup");
if (confirmOpenOffersPopup) {
  var _closeBtn = confirmOpenOffersPopup.querySelector('.confirm-open-offers--popup__close');
  if (_closeBtn) {
    _closeBtn.addEventListener('click', function () {
      confirmOpenOffersPopup.classList.remove('active');
    });
  }
}
var aboutUs = document.querySelector('.about-us');
if (aboutUs) {
  var onEntry = function onEntry(entry) {
    entry.forEach(function (change) {
      if (change.isIntersecting) {
        change.target.classList.add('element-show');
      }
    });
  };
  var options = {
    threshold: [0.1]
  };
  var observer = new IntersectionObserver(onEntry, options);
  var elements = document.querySelectorAll('.element-animation');
  var _iterator2 = _createForOfIteratorHelper(elements),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var elm = _step2.value;
      observer.observe(elm);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if ($(window).width() <= '992') {
    var readAboutUs = new Swiper('.read__about-us-container', {
      //need rewrite
      wrapperClass: "read__about-us-wrapper",
      slideClass: "read__about-us-slide",
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      breakpoints: {
        640: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 3
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 1
      }
    });
  }
}
var ourCommunityBlock = document.querySelector('.our-community');
if (ourCommunityBlock) {
  var time = 1,
    cc = 1;
  $(window).scroll(function () {
    $('.our-community').each(function () {
      var cPos = $(this).offset().top,
        topWindow = $(window).scrollTop();
      if (cPos < topWindow + 500) {
        if (cc < 2) {
          $(".our-community_num").addClass("active");
          $('div').each(function () {
            var i = $(this).data('num') - 150,
              num = $(this).data('num'),
              step = 1,
              that = $(this),
              _int = setInterval(function () {
                if (i <= num) {
                  that.html(i);
                } else {
                  cc = cc + 1;
                  clearInterval(_int);
                }
                i++;
              }, step);
          });
        }
      }
    });
  });
}
var ourMissionBlock = document.querySelector('.our-mission');
if (ourMissionBlock) {
  var time = 1,
    cc = 1;
  $(window).scroll(function () {
    $('.our-mission').each(function () {
      var cPos = $(this).offset().top,
        topWindow = $(window).scrollTop();
      if (cPos < topWindow + 650) {
        if (cc < 2) {
          $(".title").addClass("active");
          $('div').each(function () {
            var i = $(this).data('num') - 150,
              num = $(this).data('num'),
              step = 1,
              that = $(this),
              _int2 = setInterval(function () {
                if (i <= num) {
                  that.html(i);
                } else {
                  cc = cc + 1;
                  clearInterval(_int2);
                }
                i++;
              }, step);
          });
        }
      }
    });
  });
}
var partnersPage = document.querySelector('.partners-page');
if (partnersPage) {
  var resizeSliders = function resizeSliders() {
    var wrapperSlider = document.querySelector(".eco-system-wrapper");
    if (wrapperSlider) {
      var listSlider = document.querySelectorAll(".eco-system-slide");
      var arrSliders = [];
      wrapperSlider.style.height = "auto";
      listSlider.forEach(function (item) {
        item.style.height = "auto";
        arrSliders.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(Math, arrSliders);
      wrapperSlider.style.height = maxHeight + 20 + "px";
    }
  };
  var ecoSystem = new Swiper('.eco-system-content', {
    lazy: true,
    wrapperClass: "eco-system-wrapper",
    slideClass: "eco-system-slide",
    slidesPerView: 1,
    // loop: true,
    spaceBetween: 20,
    breakpoints: {
      600: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 3
      }
    },
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
      dynamicMainBullets: 1
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });
  resizeSliders();
}